import api from '@/js/services/api';
export default {
    addNewTodo(form) {
        return api().post(`/master-admin/to-do/store`, form);
    },
    addNewComment(todo_id, comment) {
        return api().post(`/master-admin/to-do/${todo_id}/comment/create`, {comment});
    },
    deleteTodo(id) {
        return api().delete(`/master-admin/to-do/` + id + `/delete`);
    },
    deleteComment(id) {
        return api().delete(`/master-admin/to-do/comment/${id}/delete`);
    },
    forwardTodoTo(todo_id,applicant_id) {
        return api().post(`/master-admin/to-do/${todo_id}/forward`, {'forwardToId': applicant_id});
    },
    getTodoList(filters) {
        const searchParams = new URLSearchParams();

        for (const [key, value] of Object.entries(filters)) {
            searchParams.append(key, value)
        }

        return api().get('/master-admin/to-do/get?' + searchParams.toString())
    },
    getTodoInfo(id) {
        return api().get(`/master-admin/to-do/${id}/get`);
    },
    updateTodo(todo_id, todoFields) {
        return api().put(`/master-admin/to-do/${todo_id}/update`, todoFields);
    },
    updateComment(id, comment) {
        return api().put(`/master-admin/to-do/comment/${id}/update`, {comment})
    }



}
